module.exports = __webpack_public_path__ + "static/media/fruitbonbon.6aee105f.png";